import ApiClient from '../ApiClient';

class Wazzup24Channel extends ApiClient {
  constructor() {
    super('channels/wazzup24', { accountScoped: true });
  }
}

export default new Wazzup24Channel();
